import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Badge from 'react-bootstrap/Badge';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import TimesheetItem from './timesheet-item';
import Skeleton from 'react-loading-skeleton'
import { prepareForm, getFullName, formatMonthYear, getAvailableMonths2, getFromLocalStorage, setLocalStorage, formatDateTime, getExpenseStatus, forceTwoDigits, lpad, removeTimestampFromFilename } from "./../../utils";
import { toJS } from 'mobx'
import DocumentsAdmin from '../../components/documents/documents.admin';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FormText from './../inputs/text';
import Spinner from 'react-bootstrap/Spinner';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import ConfirmPopup from './../modal/modal';
import { saveAs } from 'file-saver';
import { publish } from "./../../events";
import NumberFormatted from './../../shared/components/numberFormatted';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";

const Timesheet = (props) => {
    const [pdfData, setPdfData] = useState(null);

    const { state } = useLocation();

    let navigate = useNavigate();
    const { usersAdminStore, loginStore, activitiesStore, timesheetStore, winbizStore, fileStore } = useStores();
    const { getAllUsers, users, user, ignoreMessage, setInformation, sendEmail } = usersAdminStore;
    const { getUserActivities, userActivities } = activitiesStore;
    const { syncWinbiz, syncWages, syncExpenses, syncExpensesAccounting, syncExpensesPurchasing, syncExpensesSalary } = winbizStore;
    const { getFullReportFile, getDocumentFile, deleteDocument } = fileStore;

    const { getDevsMonth, month, updateDate, setFinished, expensesSummary, getExpensesSummary, approveInternalExpense, rejectInternalExpense, getPackageDetailReport, getCostsReport, sendToPendingValidation } = timesheetStore;
    const { t, i18n } = useTranslation();
    const { accountInfo } = loginStore;
    const [show, setShow] = useState(false);
    const [showRejectInternalExpenseModal, setShowRejectInternalExpenseModal] = useState(false);
    const [rejectValidated, setRejectValidated] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(null);
    //const { month } = state;
    const { id } = useParams();
    const firstTime = useRef(true);
    const [initialDate, setInitialDate] = useState(null);
    const [showReport, setShowReport] = useState(false);
    const closeShowReport = () => {
        setPdfData(null);
        setShowReport(false);
    }

    const showFile = (result, filename) => {

        var fileReader = new FileReader();
        fileReader.onload = function (event) {
            setPdfData({
                data: event.target.result,
                filename: filename
            });
        };
        fileReader.readAsArrayBuffer(result.bytes);
        setShowReport(true);
    }

    const handleInfoSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = prepareForm(event, false, ["id"]);

            if (fields.isUserInfo) {
                setInformation(formData).then(() => {

                    setShowEdit(false);
                    month.developer.information = formData.message;
                })
            } else {
                changeStatus(formData.message, 6);
            }
        }
    };

    useEffect(() => {
        if (firstTime.current) {
            loadActivities();
            firstTime.current = false;
        }
    });


    const getStatuses = (month) => {
        return month?.devMonthStatus ?? null;
    }
    const [billed, setBilled] = useState(false);
    const [sent, setSent] = useState(false);
    const [winbiz, setWinbiz] = useState(false);
    const [salary, setSalary] = useState(false);
    const [expense, setExpense] = useState(false);
    const [isFinished, setIsFinished] = useState(false);

    const loadActivities = () => {

        setIsLoading(true);
        Promise.all([getDevsMonth(id), getUserActivities(id), getExpensesSummary(id)]).then(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        setBilled(month?.devMonthStatus?.billed ? new Date(month?.devMonthStatus?.billed) : null);
        setSent(month?.devMonthStatus?.sent ? new Date(month?.devMonthStatus?.sent) : null);
        setWinbiz(month?.devMonthStatus?.winbizSync ? new Date(month?.devMonthStatus?.winbizSync) : null);
        setSalary(month?.devMonthStatus?.salarySync ? new Date(month?.devMonthStatus?.salarySync) : null);
        setExpense(month?.devMonthStatus?.expense ? new Date(month?.devMonthStatus?.expense) : null);
        setIsFinished(month?.devMonthStatus?.finished ?? false);
    }, [month]);

    const anyPendingSyncInvoices = () => getInvoices()?.some(x => x.sentWinbiz == null);
    const getInvoices = () => {


        if (!id)
            return [];

        var invoices = month?.invoices/*?.filter(x => !x.deleted)*/;

        var list = [];

        invoices?.forEach(i => {
            list.push(i);
            if (i.creditNote)
                list.push(i.creditNote)
        });

        return list;
    }

    const getInitialDate = () => {

        var date = new Date();
        //Set default date
        if (id) { //Set month from filter                
            var p = id?.split("_");
            date = p?.length >= 3 ? new Date(p[2], p[1] - 1, 1) : new Date();
        } else { //Set month as earlier editable month or current month if all fails
            var found = getAvailableMonths2(userActivities, props.role);
            date = found?.length > 0 ? found[0] : new Date();
        }



        return date;
    }

    const [showInfo, setShowInfo] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [showEmail, setShowEmail] = useState(false);

    const [showEditInfo, setShowEdit] = useState(false);
    const [fields, setFields] = useState({});
    const [currentType, setCurrentType] = useState(null);
    const [isDateUpdating, setDateUpdating] = useState(false);

    const [modalSettings, setModalSettings] = useState({});
    const [showValidateConfirm, setShowValidateConfirm] = useState(false);
    const [winbizSyncing, setWinbizSyncing] = useState(false);

    const changeStatus = (state, type) => {
        if (isDateUpdating) {
            //toast.warning(t("pleaseWait"))
            return;
        }


        setCurrentType(type);
        setDateUpdating(true);

        if (type == 5) {
            setFinished(id, state).then((r) => {
                if (r?.success === true)
                    setIsFinished(state)

            }).finally(() => {
                setCurrentType(null);
                setDateUpdating(false);
            });
        } else {
            updateDate(id, type, state).then(x => {
                var val = x?.date ? new Date(x.date) : null;
                switch (type) {
                    case 0:
                        setBilled(val);
                        break;
                    case 1:
                        setSent(val);
                        break;
                    case 2:
                        setWinbiz(val);
                        break;
                    case 3:
                        setSalary(val);
                        break;
                    case 4:
                        setExpense(val)
                        break;
                    case 6:
                        if (month?.devMonthStatus == null) { month.devMonthStatus = { information: state } }
                        else { month.devMonthStatus.information = state; }
                        setShowEdit(false);
                        break;
                    default:
                        break;

                }
            }).finally(() => {
                setCurrentType(null);
                setDateUpdating(false);
            });
        }
    }

    const getValidIcon = (condition) => condition ? solid("check") : solid("xmark");

    const handleEmailSubmit = (event) => {

        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {

            const formData = prepareForm(event, false, ["id"]);
            sendEmail(formData).then(() => {
                setShowEmail(false);
            });

        }
        setEmailValidated(true);
    };
    const [emailValidated, setEmailValidated] = useState(false);
    const getFilesForActivities = () => {
        //var options = [...new Map(userActivities?.filter(x => x.id > 0).map(item => [item["id"], item])).values()]?.map(x => x.documents)?.filter(x => x.length > 0)?.reduce((p, c) => p.concat(c), []);/*?.map(x => { return { id: x.id, name: x.name } })*/;

        var options = userActivities?.filter(x => x.id > 0);
        var result = [];

        for (var i = 0; i < options.length; i++) {
            var a = options[i];

            for (var j = 0; j < a.documents.length; j++) {
                var doc = a.documents[j];

                result.push({ id: doc.id, filename: doc.filename, month: doc.month, year: doc.year, activityName: a?.name, clientName: a?.project?.client?.name });
            }
        }

        return result.filter(x => (x.month === month.month && x.year === month.year));
    }

    const [showFiles, setShowFiles] = useState(false);

    const handleRejectSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            const formData = Object.fromEntries(new FormData(event.target).entries());
            rejectInternalExpense(id, formData?.rejectReason);
            setShowRejectInternalExpenseModal(false);
        }
        setRejectValidated(true);

    }

    function getInternalExpensesStatus(status) {
        switch (status) {
            case 0:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={solid("spinner")} />
                    <b> {t('initial')}</b>
                </div>;
            case 1:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={solid("spinner")} />
                    <b> {t('pendingForApproval')}</b>
                </div>;
            case 2:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={regular("circle-check")} />
                    <b> {t('validated')}</b>
                </div>;
            case 3:
                return <div style={{ marginLeft: '20px' }}>
                    <FontAwesomeIcon className="mx-1" size="2x" icon={solid("ban")} />
                    <b> {t('rejected')}</b>
                </div>;
            default:
                return <span></span>;
        }
    }

    return (
        <Stack>
            <ConfirmPopup show={showValidateConfirm} onClose={() => { setShowValidateConfirm(false) }} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />
            <Modal show={showEmail} onHide={() => setShowEmail(false)}>
                <Form noValidate validated={emailValidated} onSubmit={handleEmailSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("sendUserMessage")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack gap={2}>
                            <FormText id="id" hidden object={month?.developer} />
                            <FormText required lines={5} placeholder={t("enterMessage")} label={t("message")} id="message" />
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                            {t("send")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showEditInfo} onHide={() => setShowEdit(false)}>
                <Form noValidate onSubmit={handleInfoSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t(fields?.isUserInfo ? "editUserInformation" : "editInformation")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack gap={2}>
                            <FormText id="id" hidden object={fields} />
                            <FormText lines={5} label={t("information")} id="message" object={fields} />
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                            {t("save")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showMessage} onHide={() => setShowMessage(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("message")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Stack gap={2}>
                        <span>{month?.developer?.name} {month?.developer?.surname} {t("messageReceived")}</span>
                        <span style={{ whiteSpace: "pre-line" }}><i>{month?.developer?.message}</i></span>
                    </Stack>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={(e) => {
                        setShowMessage(false)
                    }}>{t("ok")}</Button>
                    <Button variant="primary" onClick={(e) => {
                        ignoreMessage(month?.developer?.id).then(() => {
                            month.developer.message = null;
                            setShowMessage(false)
                            publish("messageIgnored");
                        });

                    }}>{t("ignore")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showInfo} onHide={() => { setShowInfo(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("consultantInfo")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Stack gap={2}>
                        <span><b>{t("username")}</b>: {month?.developer?.username}</span>
                        <span><b>{t("name")}/{t("surname")}</b>: {month?.developer?.name} {month?.developer?.surname}</span>
                        <span><b>{t("email")}</b>: {month?.developer?.email}</span>
                        {month?.developer?.salaryCompany && <u><b>{t("salary")}:</b></u>}
                        {month?.developer?.salaryCompany && <span><b>{t("company")}</b>: {month?.developer?.salaryCompany?.name}</span>}
                        {month?.developer?.salaryCurrency && <span><b>{t("currency")}</b>: {month?.developer?.salaryCurrency?.shortName}</span>}
                    </Stack>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowInfo(false)}>{t("ok")}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showFiles} onHide={() => { setShowFiles(false); setPdfData(null) }} size={"xl"}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("files")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {getFilesForActivities()?.length > 0 ? <Table>

                        <tbody>
                            <tr>
                                <th>{t("file")}</th>
                                <th>{t("activity")}</th>
                                <th></th>
                            </tr>
                            {getFilesForActivities()?.map((f, i) => {
                                return (
                                    <tr key={i} className="align-middle">
                                        <td >
                                            <Button variant="link" style={{ color: "#D12B3C", padding: 0, textAlign: "left" }} onClick={(e) => {
                                                e.preventDefault();
                                                getDocumentFile(f.id).then((b) => {
                                                    var fileReader = new FileReader();
                                                    fileReader.onload = function (event) {
                                                        setPdfData({
                                                            data: event.target.result,
                                                            filename: f.filename
                                                        });
                                                    };
                                                    fileReader.readAsArrayBuffer(b.bytes);
                                                    //saveAs(new Blob([b.bytes]), f.filename)
                                                })
                                            }}>{f.filename}</Button>
                                        </td>
                                        <td>{f.clientName} - {f.activityName}</td>
                                        <td>

                                            <Button className="float-end border" variant="outline" onClick={() => {
                                                setModalSettings({
                                                    title: t("delete"),
                                                    body: t('confirmDelete'),
                                                    onConfirm: () => {
                                                        deleteDocument(f.id).then(() => {
                                                            setShowFiles(false);
                                                            loadActivities();
                                                        })
                                                    }
                                                });
                                                setShowValidateConfirm(true)

                                            }}>
                                                <FontAwesomeIcon icon={solid("trash")} />
                                            </Button>

                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                        :
                        <span>{t("noRecords")}</span>
                    }
                    {pdfData && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "58vh" : null }}
                        saveFileName={pdfData?.filename}
                        arrayBuffer={pdfData?.data} tools={[
                            "pager",
                            "spacer",
                            "zoomInOut",
                            "zoom",
                            "selection",
                            "spacer",
                            "search",/*,
                            "open",*/
                            "download"/*,
                            "print",*/]}
                    /></LocalizationProvider>}
                </Modal.Body>
            </Modal>

            <Modal className="modal-xl" show={showReport} onHide={() => closeShowReport()}>
                <Modal.Header closeButton>
                    <Modal.Title>{pdfData?.filename}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "75vh" : null }}
                        saveFileName={pdfData?.filename}
                        arrayBuffer={pdfData?.data} tools={["pager", "spacer", "zoomInOut", "zoom", "selection", "spacer", "search", "download"]}
                    /></LocalizationProvider>}
                </Modal.Body>
            </Modal>

            <Modal show={showRejectInternalExpenseModal} onHide={() => setShowRejectInternalExpenseModal(false)}>
                <Form noValidate validated={rejectValidated} onSubmit={handleRejectSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("rejectInternalExpense")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Stack gap={2}>
                            <FormText lines={4} required label={`${t("reason")}:`} id="rejectReason" isLoading={isLoading} />
                        </Stack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { setShowRejectInternalExpenseModal(false) }}>{t("no")}</Button>
                        <Button variant="success" type="submit">{t("yes")}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Card className="mb-3">
                <Card.Body>

                    <Stack direction="horizontal" gap={2} style={{ alignItems: "start" }}>

                        <div style={{ alignSelf: "center" }}>
                            <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../")} size="small" />
                        </div>

                        <Col>
                            <Stack>
                                {isLoading ? <Skeleton width={100} /> : <span><b>{month?.developer?.username}</b></span>}
                                {isLoading ? <Skeleton width={100} /> : <span>{getFullName(month?.developer)}</span>}
                                {isLoading ? <Skeleton width={100} /> : <span>{formatMonthYear(new Date(month.year, month.month - 1, 1))}</span>}
                                {isLoading ? <Skeleton width={100} /> : <span>{month?.project?.client?.name}</span>}

                                {isLoading ? <Skeleton width={100} /> : <span onClick={(e) => {

                                    e.preventDefault();
                                    e.stopPropagation();
                                    setFields({ id: month?.developer?.id, message: month?.developer?.information, isUserInfo: true });
                                    setShowEdit(true);
                                }}
                                    style={{
                                        cursor: "pointer",
                                        padding: "0px 8px",
                                        border: "1px solid lightGray", fontSize: "13px", backgroundColor: "#f9f9f9",
                                    }}>
                                    <span style={{ whiteSpace: "pre-line" }} title={t("clickToEdit")}>
                                        {month?.developer?.information ? month?.developer?.information : (<i>{t("noUserInfo")}</i>)}
                                    </span>
                                </span>}

                            </Stack>
                        </Col>
                        <Col>
                            <Stack>

                                {isLoading ? <Skeleton width={100} /> : <span>{t("activities")}</span>}
                                <span></span>

                                {isLoading ? <Skeleton width={100} /> : <span>
                                    <Badge className="mx-1" bg="secondary">{month?.pendingConsultantCount}</Badge>
                                    {t("pendingConsultant")}
                                </span>}
                                {isLoading ? <Skeleton width={100} /> : <span>
                                    <Badge className="mx-1" bg="secondary">{month?.pendingValidationCount}</Badge>
                                    {t("pendingValidation")}
                                </span>}
                                {isLoading ? <Skeleton width={100} /> : <span>
                                    <Badge className="mx-1" bg="secondary">{month?.rejectedCount}</Badge>
                                    {t("rejected")}
                                </span>}
                                {isLoading ? <Skeleton width={100} /> : <span>
                                    <Badge className="mx-1" bg="secondary">{month?.validatedCount}</Badge>
                                    {t("validatedByClient")}
                                </span>}
                                {isLoading ? <Skeleton width={100} /> : <span>
                                    <Badge className="mx-1" bg="secondary">{month?.adminValidatedCount}</Badge>
                                    {t("validated")}
                                </span>}
                                {isLoading ? <Skeleton width={100} /> : <span>
                                    <Badge className="mx-1" bg="secondary">{month?.billedCount}</Badge>
                                    {t("billed")}
                                </span>}

                            </Stack>
                        </Col>

                        <Col xs={3}>
                            <Stack>
                                {isLoading ? <Skeleton width={100} /> : <span>{t("workflow")}</span>}
                                <span></span>
                                {isLoading ? <Skeleton width={100} /> : <Stack direction="horizontal" gap={2}  >
                                    <Form.Check className="pointer" type="checkbox" checked={billed ?? false} onChange={(e) => changeStatus(e.target.checked, 0)} id="billed" label={`${t("billing")}: ${(billed ? formatDateTime(billed) : "-")}`} />
                                    {(isDateUpdating && currentType == 0) && <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Loading...</span></Spinner>}
                                </Stack>}
                                {isLoading ? <Skeleton width={100} /> : <Stack direction="horizontal" gap={2}><Form.Check className="pointer" id="sent" type="checkbox" checked={sent ?? false} onChange={(e) => changeStatus(e.target.checked, 1)} label={`${t("sentDownloaded")}: ${(sent ? formatDateTime(sent) : "-")}`} />
                                    {(isDateUpdating && currentType == 1) && <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Loading...</span></Spinner>}
                                </Stack>}
                                {isLoading ? <Skeleton width={100} /> : <Stack direction="horizontal" gap={2}>
                                    <Form.Check className="pointer" id="winbiz" type="checkbox" checked={winbiz ?? false} onChange={(e) => changeStatus(e.target.checked, 2)} label={`${t("winbizSynced")}: ${(winbiz ? formatDateTime(winbiz) : "-")}`} />
                                    {(isDateUpdating && currentType == 2) && <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Loading...</span></Spinner>}
                                </Stack>}
                                {isLoading ? <Skeleton width={100} /> : <Stack direction="horizontal" gap={2}><Form.Check className="pointer" id="salary" className="pointer" type="checkbox" checked={salary ?? false} onChange={(e) => changeStatus(e.target.checked, 3)} label={`${t("salarySynced")}: ${(salary ? formatDateTime(salary) : "-")}`} />
                                    {(isDateUpdating && currentType == 3) && <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Loading...</span></Spinner>}
                                </Stack>}
                                {isLoading ? <Skeleton width={100} /> : <Stack direction="horizontal" gap={2}><Form.Check className="pointer" id="expense" type="checkbox" checked={expense ?? false} onChange={(e) => changeStatus(e.target.checked, 4)} label={`${t("expense")}: ${(expense ? formatDateTime(expense) : "-")}`} />
                                    {(isDateUpdating && currentType == 4) && <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Loading...</span></Spinner>}
                                </Stack>}
                            </Stack>
                        </Col>

                        <Col>
                            <Stack >
                                {isLoading ? <Skeleton width={200} /> : <span>{t("information")}:</span>}
                                {isLoading ? <Skeleton width={200} /> : <span className="pointer" style={{ whiteSpace: "pre-line" }} title={t("clickToEdit")}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setFields({ id: month?.developer?.id, message: month?.devMonthStatus?.information, isUserInfo: false });
                                        setShowEdit(true);
                                    }}
                                >{month?.devMonthStatus?.information ? month?.devMonthStatus?.information : (<i>{t("none")}</i>)}</span>}
                            </Stack>
                        </Col>

                        <Col>
                            {!isLoading && <Stack>
                                <Stack direction="horizontal" gap={2}>
                                    <Stack gap={2}>
                                        <Button className="w-100" disabled={winbizSyncing?.isLoading} variant="secondary" onClick={(e) => {
                                            setModalSettings({
                                                title: t("syncWinbizSalaries"), body: t("confirmWinbizSalaries"), onConfirm: () => {
                                                    setWinbizSyncing({ type: "salary", isLoading: true })
                                                    Promise.all([syncWages(id, () => loadActivities())]).then(x => {
                                                        setWinbizSyncing({ isLoading: false })
                                                        setShowValidateConfirm(false);
                                                    })
                                                    setShowValidateConfirm(false);
                                                }
                                            });
                                            setShowValidateConfirm(true)
                                        }}>
                                            {(winbizSyncing?.isLoading && winbizSyncing.type === "salary") && <Spinner animation="border" role="status" size="sm"></Spinner>}
                                            &nbsp;
                                            {t("syncWinbizSalaries")}
                                        </Button>

                                        <Button className="w-100" disabled={winbizSyncing?.isLoading} variant="secondary" onClick={async (e) => {
                                            var p = id?.split("_");
                                            if (p?.length === 3) {
                                                setWinbizSyncing({ type: "generateFullTimesheet", isLoading: true });
                                                await getFullReportFile(p[0], `${p[1]}_${p[2]}`).then(result => {
                                                    setWinbizSyncing({ isLoading: false });
                                                    showFile(result, removeTimestampFromFilename(result?.utf_filename ?? result.filename));
                                                });
                                            }
                                        }}>
                                            {(winbizSyncing?.isLoading && winbizSyncing.type === "generateFullTimesheet") && <Spinner animation="border" role="status" size="sm"></Spinner>}
                                            &nbsp;
                                            {t("generateFullTimesheet")}
                                        </Button>

                                        {t("syncWinbizExpenses")}:

                                        <Stack direction="horizontal" gap={1}>
                                            <Button className="w-100" disabled={winbizSyncing?.isLoading} variant="secondary" onClick={(e) => {
                                                setModalSettings({
                                                    title: t("syncWinbizExpenses"), body: t("confirmWinbizExpenses"), onConfirm: () => {
                                                        setWinbizSyncing({ type: "expenses", isLoading: true })
                                                        Promise.all([syncExpensesAccounting(month.year, month.month, id.split("_")[0], () => loadActivities())]).then(x => {
                                                            setWinbizSyncing({ isLoading: false })
                                                            setShowValidateConfirm(false);
                                                        })
                                                        setShowValidateConfirm(false);
                                                    }
                                                });
                                                setShowValidateConfirm(true)
                                            }}>
                                                {(winbizSyncing?.isLoading && winbizSyncing.type === "expenses") && <Spinner animation="border" role="status" size="sm"></Spinner>}
                                                &nbsp;
                                                {t("accounting")}
                                            </Button>
                                            <Button className="w-100" disabled={winbizSyncing?.isLoading} variant="secondary" onClick={(e) => {
                                                setModalSettings({
                                                    title: t("syncWinbizExpenses"), body: t("confirmWinbizExpenses"), onConfirm: () => {
                                                        setWinbizSyncing({ type: "expenses", isLoading: true })
                                                        Promise.all([syncExpensesSalary(month.year, month.month, id.split("_")[0], () => loadActivities())]).then(x => {
                                                            setWinbizSyncing({ isLoading: false })
                                                            setShowValidateConfirm(false);
                                                        })
                                                        setShowValidateConfirm(false);
                                                    }
                                                });
                                                setShowValidateConfirm(true)
                                            }}>
                                                {(winbizSyncing?.isLoading && winbizSyncing.type === "expenses") && <Spinner animation="border" role="status" size="sm"></Spinner>}
                                                &nbsp;
                                                {t("salary")}
                                            </Button>
                                            <Button className="w-100" disabled={winbizSyncing?.isLoading} variant="secondary" onClick={(e) => {
                                                setModalSettings({
                                                    title: t("syncWinbizExpenses"), body: t("confirmWinbizExpenses"), onConfirm: () => {
                                                        setWinbizSyncing({ type: "expenses", isLoading: true })
                                                        Promise.all([syncExpensesPurchasing(month.year, month.month, id.split("_")[0], () => loadActivities())]).then(x => {
                                                            setWinbizSyncing({ isLoading: false })
                                                            setShowValidateConfirm(false);
                                                        })
                                                        setShowValidateConfirm(false);
                                                    }
                                                });
                                                setShowValidateConfirm(true)
                                            }}>
                                                {(winbizSyncing?.isLoading && winbizSyncing.type === "expenses") && <Spinner animation="border" role="status" size="sm"></Spinner>}
                                                &nbsp;
                                                {t("purchasing")}
                                            </Button>
                                        </Stack>
                                    </Stack>
                                    <Stack>
                                        {isLoading ? <Skeleton /> : <Button style={{ width: 150, alignSelf: "end" }} variant="secondary" onClick={(e) => {
                                            changeStatus(!isFinished, 5);
                                        }}>

                                            {t(isFinished ? "reopen" : "finish")}&nbsp;
                                            {(isDateUpdating && currentType == 5) && <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Loading...</span></Spinner>}
                                        </Button>}
                                        {isLoading ? <Skeleton /> : <span style={{ alignSelf: "end" }}>{t("currentStatus")}: {t(isFinished ? "finished" : "open")}</span>}
                                    </Stack>
                                </Stack>

                                <Row style={{ height: "100%", alignContent: "end" }}>


                                    <Col className="ms-auto" />
                                    <Col md="auto" >
                                        <Stack direction="horizontal" gap={2}>
                                            {/*getFilesForActivities()?.length > 0 && <Button className="p-0" variant="secondary" size="sm" onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setShowFiles(true);
                                            }}><FontAwesomeIcon className="mx-1" icon={solid("file")} size="1x" /><Badge className="mx-1">{getFilesForActivities()?.length}</Badge></Button>*/}

                                            {month?.developer?.message && <Button className="p-0" variant="secondary" size="sm" onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setShowMessage(true);
                                            }}><FontAwesomeIcon className="mx-1" icon={solid("comment")} size="1x" /><Badge className="mx-1" bg="danger">1</Badge></Button>}

                                            <Button className="p-0" variant="secondary" size="sm" onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setEmailValidated(false);
                                                setShowEmail(true);
                                            }}><FontAwesomeIcon className="mx-1" icon={solid("envelope")} size="1x" /></Button>
                                        </Stack>

                                    </Col>
                                </Row>

                            </Stack>}
                        </Col>
                    </Stack>

                </Card.Body>
            </Card>


            <Tabs defaultActiveKey="pendingConsultant">

                <Tab eventKey="pendingConsultant" title={t("pendingConsultant")}>
                    <TimesheetItem users={users} isLoading={isLoading} state={0} role={accountInfo?.role} items={userActivities} filter={id} initialDate={getInitialDate()} />
                </Tab>

                <Tab eventKey="pendingClient" title={t("pendingValidationClient")}>
                    <TimesheetItem users={users} isLoading={isLoading} state={1} role={accountInfo?.role} items={userActivities} filter={id} initialDate={getInitialDate()} />
                </Tab>

                <Tab eventKey="rejected" title={t("rejected")}>
                    <TimesheetItem users={users} isLoading={isLoading} state={2} role={accountInfo?.role} items={userActivities} filter={id} initialDate={getInitialDate()} />
                </Tab>
                <Tab eventKey="clientValidate" title={t("validatedByClient")}>
                    <TimesheetItem users={users} isLoading={isLoading} state={3} role={accountInfo?.role} items={userActivities} filter={id} afterSave={() => loadActivities()} initialDate={getInitialDate()} />
                </Tab>
                <Tab eventKey="chValidate" title={t("validated")}>
                    <TimesheetItem users={users} isLoading={isLoading} state={4} role={accountInfo?.role} items={userActivities} initialDate={getInitialDate()} afterSave={() => loadActivities()} />
                </Tab>
                <Tab eventKey="finalized" title={t("finalized")}>
                    <TimesheetItem users={users} isLoading={isLoading} state={5} role={accountInfo?.role} items={userActivities} filter={id} initialDate={getInitialDate()} afterSave={() => loadActivities()} />
                </Tab>
                <Tab eventKey="billed" title={t("billed")}>
                    <DocumentsAdmin billing={true} items={getInvoices()} afterSend={() => loadActivities()} isLoading={isLoading} />
                </Tab>



            </Tabs>

            {expensesSummary &&
                <Card className="mt-3">
                    <Card.Body>
                        <Row>
                            {
                                expensesSummary.expensesWithPackages?.length > 0 || expensesSummary.expensesWithActualCosts?.length > 0 ?
                                    <Col xs={3}>
                                        <Stack className="ms-auto" direction="horizontal">
                                            <b>{t('status')}</b>
                                            {
                                                isLoading ?
                                                    <Skeleton width={100} /> :
                                                    getInternalExpensesStatus(expensesSummary?.internalExpensesStatus)
                                            }

                                        </Stack>
                                    </Col>
                                    :
                                    <Col xs={3}>
                                    </Col>
                            }

                            <Col xs={9}>
                                {
                                    expensesSummary.internalExpensesStatus == 1 ?
                                        <>
                                            <button disabled={isLoading} className="float-end btn btn-secondary" type="button"
                                                onClick={() => approveInternalExpense(id)}>
                                                {t('validateInternalExpense')}
                                            </button>
                                        </> :
                                        <></>
                                }
                                {
                                    expensesSummary.internalExpensesStatus == 1 ?
                                        <>
                                            <button disabled={isLoading} style={{ marginRight: '10px' }} className="float-end btn btn-danger" type="button"
                                                onClick={() => setShowRejectInternalExpenseModal(true)}>
                                                {t('rejectInternalExpense')}
                                            </button>
                                        </> :
                                        <></>
                                }
                                {
                                    expensesSummary.internalExpensesStatus == 2 ?
                                        <>
                                            <button disabled={isLoading} style={{ marginRight: '10px' }} className="float-end btn btn-secondary" type="button"
                                                onClick={() => sendToPendingValidation(id)}>
                                                {t('sendToPendingValidation')}
                                            </button>
                                        </> :
                                        <></>
                                }
                            </Col>
                        </Row>

                        {expensesSummary.expensesWithPackages?.length > 0 &&
                            <Row>
                                <Col xs={4}>
                                    {isLoading ? <Skeleton width="300px" /> :


                                        <Stack direction="horizontal" gap={2}>
                                            <button style={{ padding: 0 }} className="btn btn-link"
                                                onClick={() => { navigate(`/expenses/with-package/${month.year}/${month.month - 1}/${id.split("_")[0]}`) }}>
                                                <FontAwesomeIcon icon={solid("magnifying-glass")} /> {t('internalExpensesWithPackages')}

                                            </button>


                                            {<Button className="p-0" variant="secondary" size="sm" title={t("pdfReport")}
                                                onClick={async () => {

                                                    if (!expensesSummary?.packageExpenseId)
                                                        toast.error(t("ExpenseNotFound"))
                                                    else {
                                                        setFileLoading({ type: "package", id: expensesSummary.packageExpenseId })
                                                        await getPackageDetailReport(expensesSummary.packageExpenseId, true)
                                                            .then((b) => showFile(b, `${month?.developer?.username} ${month.year} ${lpad(month.month, 2)} Note de frais.pdf`))
                                                        setFileLoading(null);
                                                    }
                                                }
                                                }
                                            >{fileLoading && fileLoading?.type === "package" && fileLoading?.id === expensesSummary.packageExpenseId ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon className="mx-1" icon={solid("file-lines")} size="1x" />}</Button>}
                                            <FontAwesomeIcon title={`${t("winbiz")}: ${t("accounting")} ${expensesSummary?.accountingSyncDate ? `(${formatDateTime(expensesSummary?.accountingSyncDate)})` : ""}`} className="mx-1" icon={getValidIcon(expensesSummary?.winbizAccounting)} size="1x" />
                                            <FontAwesomeIcon title={`${t("winbiz")}: ${t("salary")} ${expensesSummary?.salarySyncDate ? `(${formatDateTime(expensesSummary?.salarySyncDate)})` : ""}`} className="mx-1" icon={getValidIcon(expensesSummary?.winbizSalary)} size="1x" />
                                            <FontAwesomeIcon title={`${t("winbiz")}: ${t("purchasing")} ${expensesSummary?.purchasingSyncDate ? `(${formatDateTime(expensesSummary?.purchasingSyncDate)})` : ""}`} className="mx-1" icon={getValidIcon(expensesSummary?.winbizPurchasing)} size="1x" />
                                        </Stack>


                                    }

                                </Col>
                                <Col xs={6}>
                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>{t('category')}</th>
                                                <th className="text-end">{t('quantity')}</th>
                                                <th className="text-end">{t('unitAmount')}</th>
                                                <th className="text-end">{t('total')}</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                isLoading ?
                                                    (
                                                        Array.from(Array(6), (e, i) => {
                                                            return <tr key={i}>
                                                                <td><Skeleton /></td>
                                                                <td><Skeleton /></td>
                                                                <td><Skeleton /></td>
                                                                <td><Skeleton /></td>
                                                            </tr>
                                                        })
                                                    )
                                                    :
                                                    expensesSummary.expensesWithPackages.map((expense, index) => (
                                                        <tr key={index}>
                                                            <td>{t(expense.category)}</td>
                                                            <td className="text-end">{expense.category == "telephoneIT" ?
                                                                <NumberFormatted number={expense.quantity} />
                                                                : expense.quantity}
                                                            </td>
                                                            <td className="text-end"><NumberFormatted number={expense.unitAmount} /></td>
                                                            <td className="text-end"><NumberFormatted number={expense.total} /></td>
                                                        </tr>
                                                    ))
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan={3}><b>{t('total')}</b></td>
                                                <td className="text-end"><b>{isLoading ? <Skeleton /> : <NumberFormatted number={expensesSummary.expensesWithPackagesTotal} />}</b></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </Col>
                            </Row>
                        }

                        {expensesSummary.expensesWithActualCosts?.length > 0 && <Row>
                            <Col xs={4}>
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '100%', border: 0 }}>&nbsp;</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            isLoading ?
                                                <tr><th><Skeleton width="300px" /></th></tr>
                                                :
                                                expensesSummary.expensesWithActualCosts.map((s, index) => (
                                                    <tr key={index}>
                                                        <td style={{ border: 0 }}>
                                                            <Stack direction="horizontal" gap={2}>
                                                                <button style={{ padding: 0 }} className="btn btn-link"
                                                                    onClick={() => { navigate(`/expenses/with-costs/${month.year}/${month.month}/${s.currency.id}/${id.split("_")[0]}`) }}>
                                                                    <FontAwesomeIcon icon={solid("magnifying-glass")} /> {t('internalExpensesWithActualCosts')} {s.currency?.shortName}
                                                                </button>

                                                                {<Button className="p-0" variant="secondary" size="sm" title={t("pdfReport")}
                                                                    onClick={async () => {
                                                                        if (!s.id)
                                                                            toast.error(t("ExpenseNotFound"))
                                                                        else {
                                                                            setFileLoading({ type: "costs", id: s.id })
                                                                            await getCostsReport(s.id, true)
                                                                                .then((b) => showFile(b, `${month?.developer?.username} ${month.year} ${lpad(month.month, 2)} Frais r\u00E9els ${s.currency?.shortName}.pdf`))
                                                                            setFileLoading(null);
                                                                        }
                                                                    }}
                                                                >{fileLoading && fileLoading?.type === "costs" && fileLoading?.id === s.id ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon className="mx-1" icon={solid("file-lines")} size="1x" />}</Button>}

                                                                <FontAwesomeIcon title={`${t("winbiz")}: ${t("accounting")}  ${s?.accountingSyncDate ? `(${formatDateTime(s?.accountingSyncDate)})` : ""}`} className="mx-1" icon={getValidIcon(s?.winbizAccounting)} size="1x" />
                                                                <FontAwesomeIcon title={`${t("winbiz")}: ${t("salary")}  ${s?.salarySyncDate ? `(${formatDateTime(s?.salarySyncDate)})` : ""}`} className="mx-1" icon={getValidIcon(s?.winbizSalary)} size="1x" />
                                                                <FontAwesomeIcon title={`${t("winbiz")}: ${t("purchasing")}  ${s?.purchasingSyncDate ? `(${formatDateTime(s?.purchasingSyncDate)})` : ""}`} className="mx-1" icon={getValidIcon(s?.winbizPurchasing)} size="1x" />

                                                            </Stack>
                                                        </td>
                                                    </tr>))
                                        }
                                    </tbody>
                                </table>

                            </Col>
                            <Col xs={6}>
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th className="text-end" style={{ width: '20%' }}>{t('totalAmount')}</th>
                                            <th className="text-end" style={{ width: '20%' }}>{t('vatCollected')}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            isLoading ?
                                                (
                                                    Array.from(Array(6), (e, i) => {
                                                        return <tr key={i}>
                                                            <td><Skeleton /></td>
                                                            <td><Skeleton /></td>

                                                        </tr>
                                                    })
                                                )
                                                :
                                                expensesSummary.expensesWithActualCosts.map((item, idx) => (
                                                    <tr key={idx}>

                                                        <td className="text-end">{item.currency?.shortName} <NumberFormatted number={item.totalAmount} /></td>
                                                        <td className="text-end">{item.currency?.shortName} <NumberFormatted number={item.totalVAT} /></td>
                                                    </tr>
                                                ))

                                        }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>}



                    </Card.Body>
                </Card>
            }
        </Stack>
    );
};

export default observer(Timesheet);
